import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import { Input, Button } from 'bootstrap';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) =>
          row.getIn(['editing', 'type']) === EditableCellTypes.ItemNumber,
      ),
    ),
  ],

  displayName: 'ItemNumberModal',

  render() {
    return (
      <Modal
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Item Number"
      >
        {this._getInputNode()}
        <Button onClick={this._handleDone}>Done</Button>
      </Modal>
    );
  },

  _getInputNode() {
    let { rowState } = this.state;

    if (!rowState) return null;

    return (
      <Input
        type="text"
        ref="itemNumberInput"
        defaultValue={rowState.item.get('number')}
      />
    );
  },

  _handleDone() {
    let val = this.refs.itemNumberInput.getValue();

    CuesheetCellActions.saveItemNumber(this.state.rowState.rowIndex, val);

    ModalActions.hide(this._getModalId());
  },

  _getModalId() {
    return UIRegions.CuesheetItemNumber;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
